import { head } from 'lodash-es'

export default {
  computed: {
    batteryUpgrades() {
      const [client, upgrades] = head(Object.entries(this.upgradeAttributes)) || []
      const groupPrice = head(this.groupPrices?.[client] || [])
      const currency = groupPrice ? groupPrice.currency : ''
      return {
        ...upgrades?.BATTERY,
        currency,
        client,
      }
    },
    batteryUpgradeIdentifier() {
      return this.batteryUpgrades ? this.batteryUpgrades?.identifier : undefined
    },
  },
}
